module.exports = __webpack_public_path__ + "static/media/provider3.713131a4.png";